import { Button, Flex, Modal, Typography } from "antd";

import FolderOpenIcon from "@/icons/FolderOpenIcon";

import styles from "./search-file-modal.module.css";

const getFileName = (file) => {
  if (!file) return "";

  const baseName = file.name || file.original_name || "Без названия";
  const hasExtension = file.extension
    ? baseName.toLowerCase().endsWith(`.${file.extension.toLowerCase()}`)
    : false;

  if (!file.extension || hasExtension) return baseName;

  return `${baseName}.${file.extension}`;
};

const getFileLocationText = (file, isAdmin) => {
  const root = isAdmin ? "Административная панель" : "Главная";

  const folderPath = file?.fullPath;

  const parts = [root, "Файлы"];

  if (folderPath) {
    const formattedPath = folderPath
      .split("/")
      .map((part) => part.trim())
      .filter(Boolean)
      .join(" / ");

    if (formattedPath) {
      parts.push(formattedPath);
    }
  }

  return parts.join(" / ");
};

const SearchFileModal = ({
  visible,
  file,
  isAdmin,
  onCancel,
  onOpenFolder,
  onDownload,
}) => (
  <Modal
    width={600}
    destroyOnHidden
    maskClosable={false}
    open={visible}
    onCancel={onCancel}
    title={
      <Flex align="center" gap={10}>
        <FolderOpenIcon style={{ color: "#777", fontSize: 20 }} />
        <span>Файл</span>
      </Flex>
    }
    footer={
      <Flex justify="flex-end" gap={10}>
        <Button type="primary" onClick={onDownload}>
          Скачать
        </Button>

        <Button onClick={onOpenFolder}>Перейти в раздел</Button>
      </Flex>
    }
  >
    <Flex vertical gap={20}>
      <Flex vertical gap={4}>
        <Typography.Text className={styles.label}>
          Название объекта
        </Typography.Text>
        <Typography.Text className={styles.value}>
          {getFileName(file)}
        </Typography.Text>
      </Flex>

      <Flex vertical gap={4}>
        <Typography.Text className={styles.label}>Расположение</Typography.Text>
        <Typography.Text className={styles.value}>
          {getFileLocationText(file, isAdmin)}
        </Typography.Text>
      </Flex>
    </Flex>
  </Modal>
);

export default SearchFileModal;
